import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'
import {
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../functions/utils'

export const carouselModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.carousel_modal_title,
    html: delayHtml,

    willOpen: () => {
      // Handles old data of delay system
      handleOldDataOfDelay(oldData)
    },

    preConfirm: () => {
      // Handles data of delay system
      const delayData = handleDataOfDelay()
    
      return {
        ...delayData,
      }
    },    
  })
}